import { apiWrapper } from "apis/CommonApi";
import React, { useEffect, useState, useRef } from "react";
import { Button, Container, Modal, Table } from "react-bootstrap";
import "./UsersPage.scss";
import * as userApi from "../apis/UsersApi";
import { Col, Form, Row } from "react-bootstrap";
import { SERVER_HOST } from "Constants";
import { convertHexToNumber, convertNumberToHex } from "utils/number";

export default function UsersPage() {
  const [dataSource, setDataSource] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userName, setUserName] = useState("");
  const [businessId, setBusinessId] = useState("");
  const [userId, setUserId] = useState("");
  const [accountPw, setAccountPw] = useState("");
  const [remsEnabled, setRemsEnabled] = useState(false);
  const [externalApiEnabled, setExternalApiEnabled] = useState(false);
  const [ciLogo, setCiLogo] = useState(null);
  const [ciLogoFileName, setCiLogoFileName] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const fileInputRef = useRef();

  // 행 더블클릭 핸들러
  const handleRowDoubleClick = (item) => {
    setSelectedUser(item);
    setUserName(item.userName);
    setBusinessId(
      item.businessId == null ? "" : convertNumberToHex(item.businessId)
    );
    setUserId(item.userId);
    setAccountPw(item.accountPassword);
    setRemsEnabled(!!item.remsEnabled);
    setExternalApiEnabled(!!item.externalApiEnabled);
    setCiLogo(item.ciLogo);
    setCiLogoFileName(item.ciLogoFileName);
    setShowDialog(true);
  };

  // 추가 버튼 클릭
  const handleAddUser = () => {
    setSelectedUser(null);
    setUserName("");
    setBusinessId("");
    setUserId("");
    setAccountPw("");
    setRemsEnabled(false);
    setExternalApiEnabled(false);
    setCiLogo(null);
    setCiLogoFileName("");
    setShowDialog(true);
  };

  // 저장(추가/수정) 핸들러
  const handleSaveUser = async () => {
    const userData = {
      userId,
      userName,
      businessId: convertHexToNumber(businessId),
      accountPassword: accountPw,
      remsEnabled,
      externalApiEnabled,
      ciLogo,
      ciLogoFileName,
    };

    if (selectedUser) {
      // 수정
      const { status, data } = await userApi.updateUser({
        ...userData,
        id: selectedUser.id,
      });
      if (status === true) {
        alert("수정 성공하였습니다.");
      } else {
        alert(`수정 실패하였습니다.\n${data}`);
      }
    } else {
      // 추가
      const { status, data } = await userApi.createUser(userData);
      if (status === true) {
        alert("저장 성공하였습니다.");
      } else {
        alert(`저장 실패하였습니다.\n${data}`);
      }
    }
    setShowDialog(false);
    fetchUsers();
  };

  // 삭제 핸들러
  const handleDeleteUsers = async (selectedIds) => {
    if (selectedRowKeys.length === 0) return;
    const confirmed = window.confirm(
      `${selectedRowKeys.length}개를 삭제하시겠습니까?`
    );
    if (confirmed) {
      await userApi.deleteUsers(selectedIds);
      fetchUsers();
    }
  };
  // URL 결합 함수
  const joinUrl = (host, path) => {
    console.log(host, path);
    host = host || "";
    path = path || "";
    if (!host.endsWith("/")) host += "/";
    if (path.startsWith("/")) path = path.slice(1);
    return host + path;
  };
  // 유저 목록 새로고침
  const fetchUsers = async () => {
    let result = await userApi.getUserList();
    const { status, data } = result;
    if (status === true) {
      setDataSource(data);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div className="print-area">
      <Container fluid className="mb-3 d-flex align-items-center">
        <h1 className="title">사용자 계정관리</h1>
        <span className="ms-auto">
          <Button className="ms-2" variant="primary" onClick={handleAddUser}>
            추가
          </Button>
          <Button
            className="ms-2"
            variant="primary"
            onClick={() => handleDeleteUsers(selectedRowKeys)}
            disabled={selectedRowKeys.length === 0}
          >
            삭제
          </Button>
        </span>
      </Container>
      <div className="rtu-reg">
        <div className="rtu-reg-table">
          <div className="table-table">
            <Table bordered hover>
              <thead className="table-header">
                <tr>
                  <th></th>
                  <th>No</th>
                  <th>사용자 이름</th>
                  <th>사업자 코드</th>
                  <th>계정 ID</th>
                  <th>계정 PW</th>
                  <th>REMS 연동</th>
                  <th>외부 API 연동</th>
                  <th>CI Logo.파일</th>
                </tr>
              </thead>
              <tbody className="table-body">
                {dataSource &&
                  dataSource.map((item, index) => (
                    <tr
                      key={index}
                      onDoubleClick={() => {
                        handleRowDoubleClick(item);
                      }}
                    >
                      <td>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={selectedRowKeys.includes(item.id)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedRowKeys([...selectedRowKeys, item.id]);
                            } else {
                              setSelectedRowKeys(
                                selectedRowKeys.filter((id) => id !== item.id)
                              );
                            }
                          }}
                        />
                      </td>
                      <td>{index + 1}</td>
                      <td>{item.userName}</td>
                      <td>
                        {" "}
                        {item.businessId == null
                          ? ""
                          : convertNumberToHex(item.businessId)}
                      </td>
                      <td>{item.userId}</td>
                      <td>{item.accountPassword}</td>
                      <td>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={!!item.remsEnabled}
                          disabled
                        />
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={!!item.externalApiEnabled}
                          disabled
                        />
                      </td>
                      <td>{item.ciLogoFileName}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>

          {showDialog && (
            <Modal
              show={showDialog}
              onHide={() => setShowDialog(false)}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  사용자 계정 {selectedUser ? "수정" : "추가"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm={3}>
                      사용자 이름
                    </Form.Label>
                    <Col>
                      <Form.Control
                        type="text"
                        value={userName}
                        onChange={(e) => setUserName(e.target.value)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm={3}>
                      사업자 코드
                    </Form.Label>
                    <Col>
                      <Form.Control
                        type="text"
                        value={businessId}
                        onChange={(e) => setBusinessId(e.target.value)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm={3}>
                      계정 ID
                    </Form.Label>
                    <Col>
                      <Form.Control
                        type="text"
                        value={userId}
                        onChange={(e) => setUserId(e.target.value)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm={3}>
                      계정 PW
                    </Form.Label>
                    <Col>
                      <Form.Control
                        value={accountPw}
                        onChange={(e) => setAccountPw(e.target.value)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm={3}>
                      REMS 연동
                    </Form.Label>
                    <Col>
                      <Form.Check
                        type="checkbox"
                        checked={remsEnabled}
                        onChange={(e) => setRemsEnabled(e.target.checked)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm={3}>
                      외부 API 연동
                    </Form.Label>
                    <Col>
                      <Form.Check
                        type="checkbox"
                        checked={externalApiEnabled}
                        onChange={(e) =>
                          setExternalApiEnabled(e.target.checked)
                        }
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm={3}>
                      CI Logo
                    </Form.Label>
                    <Col>
                      {/* 파일 input */}
                      <Form.Control
                        type="file"
                        accept="image/*"
                        ref={fileInputRef}
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            setCiLogo(file);
                            setCiLogoFileName(file.name);
                          }
                        }}
                      />
                      {/* 파일명 및 미리보기 */}
                      {ciLogo && (
                        <div style={{ marginTop: 8 }}>
                          <div>파일명: {ciLogoFileName}</div>
                          {typeof ciLogo === "string" ? (
                            <img
                              src={joinUrl(SERVER_HOST, ciLogo)}
                              alt="ciLogo preview"
                              style={{
                                maxWidth: 120,
                                maxHeight: 120,
                                marginTop: 8,
                              }}
                            />
                          ) : (
                            <img
                              src={URL.createObjectURL(ciLogo)}
                              alt="ciLogo preview"
                              style={{
                                maxWidth: 120,
                                maxHeight: 120,
                                marginTop: 8,
                              }}
                            />
                          )}
                          <button
                            type="button"
                            style={{ display: "block", marginTop: 8 }}
                            onClick={() => {
                              setCiLogo(null);
                              setCiLogoFileName("");
                              if (fileInputRef.current)
                                fileInputRef.current.value = "";
                            }}
                          >
                            파일 제거
                          </button>
                        </div>
                      )}
                    </Col>
                  </Form.Group>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={handleSaveUser} color="primary">
                  저장
                </Button>
                <Button onClick={() => setShowDialog(false)}>취소</Button>
              </Modal.Footer>
            </Modal>
          )}
        </div>
      </div>
    </div>
  );
}
